import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d3b64b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "AJOUTER DES FILTRES")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "flex justify-content-center"
}
const _hoisted_4 = {
  key: 1,
  class: "max-w-screen-xl mx-auto"
}
const _hoisted_5 = { class: "flex flex-wrap justify-center" }

import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { ICategoryFilterForm } from "@/models/filter/category/ICategoryFilterForm";
import { IPropertyNotLinkedToCategoryFilter } from "@/models/filter/property/IPropertyNotLinkedToCategoryFilter";
import { filterService } from "@/_services/filter/category/filter";
import ProgressSpinner from "primevue/progressspinner";

const formId = 'add-category-filter-form';
const redirectToLastPageBtnId = 'go-back-on-last-page';

interface IAutocompleteInputItem {
    label: string;
    value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCategoryFilterForm',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const categoryUuidRouteParam = ref<string | null>(null);
const form = ref<ICategoryFilterForm>({
    category: '',
    properties: null,
});
const isLoading = ref<boolean>(false);
onMounted(async () => {
    categoryUuidRouteParam.value = route.params.uuid as string;
    if (categoryUuidRouteParam.value) {
        await getFilterNamesForInputAutoComplete();
    }
});

const propertiesForInputAutocomplete = ref<Array<IAutocompleteInputItem>>([]);
const getFilterNamesForInputAutoComplete = () => {
    isLoading.value = true;

    return new Promise<void>((resolve, reject) => {
        ApiService.get(
            `admin/prototype-not_linked-to-category/${categoryUuidRouteParam.value}`, {
                params: { itemsPerPage: 500 },
                headers: { Accept: "application/json" },
            })
            .then((response) => {
                const data = response.data.data;
                propertiesForInputAutocomplete.value = data.map((item: IPropertyNotLinkedToCategoryFilter) => ({
                    label: item.filterName,
                    value: item.filterPropertyUuid
                }));
                resolve();
                isLoading.value = false;
            })
            .catch((error) => {
                reject(error);
            });
    });
}

const showSpinner = () => {
    isLoading.value = true;

    const formHTMLElement = document.getElementById(`${formId}`);
    if (formHTMLElement) {
        const submitBtn = formHTMLElement.querySelector('button[type="submit"]');
        const redirectToLastPageBtn = document.getElementById(`${redirectToLastPageBtnId}`);
        if (submitBtn && redirectToLastPageBtn) {
            submitBtn.disabled = true;
            redirectToLastPageBtn.disabled = true;
        }
    }
}

const hideSpinner = () => {
    isLoading.value = false;
}

const onSubmit = async (formData, formNode) => {
    const payload: ICategoryFilterForm = {
        category: categoryUuidRouteParam.value as string,
        properties: formData.properties,
    }
    
    swal.confirm(`Êtes-vous sur de vouloir ajouter le filtre ?`, "Annuler", "Oui")
        .then((responseLevel1: object) => {
            if (responseLevel1.isConfirmed) {
                showSpinner();
                filterService.createCategoryFilter(payload).then(() => {
                    hideSpinner();
                    swal.success("Succès !", "Le filtre a été créer avec succès !")
                        .then((responseLevel2) => {
                        if (responseLevel2.isConfirmed) {
                            setTimeout(() => {
                                router.push({ name: 'categoryProductFiltersManagement', params: { uuid: payload.category }});
                            }, 1000);
                        }
                    });
                });
            }
        });
};

const redirectToLastPage = () => {
    router.back();
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: redirectToLastPageBtnId,
      class: "inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLastPage()))
    }, [
      _hoisted_1,
      _createTextVNode(" Retour ")
    ]),
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(ProgressSpinner), { "aria-label": "Chargement" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormKit, {
              type: "form",
              id: formId,
              actions: false,
              model: form.value,
              onSubmit: onSubmit,
              "outer-class": "w-full",
              "incomplete-message": "Veuillez remplir tous les champs correctement"
            }, {
              default: _withCtx(({ state: { valid } }) => [
                _createVNode(_component_FormKit, {
                  type: "select",
                  name: "status",
                  label: "Type de filtre *",
                  disabled: "",
                  options: [{ label: 'Propriété', value: 'property' }],
                  "validation-messages": {required: 'Veuillez selectionner un type de filtre.'}
                }, null, 8, ["validation-messages"]),
                _createVNode(_component_FormKit, {
                  type: "autocomplete",
                  name: "properties",
                  modelValue: form.value.properties,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.properties) = $event)),
                  label: "Propriété filtrable *",
                  placeholder: "Choisissez une propriété",
                  multiple: "",
                  validation: "required",
                  "selection-appearance": "option",
                  "empty-message": "Aucune propriété trouvée",
                  options: propertiesForInputAutocomplete.value,
                  "validation-messages": {required: 'Veuillez sélectionner une ou plusieurs propriétés.'}
                }, null, 8, ["modelValue", "options", "validation-messages"]),
                _createVNode(_component_FormKit, {
                  type: "submit",
                  label: "Ajouter",
                  disabled: !valid
                }, null, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ]))
  ], 64))
}
}

})